import { AssistantExchangesResponse, AssistantLinkCodeResponse, AssistantLinksResponse, AssistantSettingsResponse, AssistantToolCallsResponse, ClaudeConnectionsResponse, MyAssistantWhatsappResponse, PlatformAccountAssistant, PlatformAssistantInstancesResponse, PlatformAssistantPairing, PlatformAssistantResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/assistant` — o assistente (F253–F255).
 *
 * Por enquanto as conexões do Claude: a URL para colar e quem conectou. Quem
 * tem `assistant.manage` recebe as de todos; os outros, só as suas.
 */
/** As últimas consultas do Claude e do assistente (F295). */
export const fetchAssistantToolCalls = async () => AssistantToolCallsResponse.parse(await request('/api/v1/assistant/tool-calls'));
export const fetchClaudeConnections = async () => ClaudeConnectionsResponse.parse(await request('/api/v1/assistant/connections'));
export const disconnectClaude = async (id) => {
    await request(`/api/v1/assistant/connections/${id}`, { method: 'DELETE' });
};
// --- O WhatsApp do assistente (F254) ----------------------------------------
export const fetchAssistantSettings = async () => AssistantSettingsResponse.parse(await request('/api/v1/assistant/settings'));
export const saveAssistantSettings = async (body) => {
    await request('/api/v1/assistant/settings', { method: 'PUT', body });
};
export const fetchAssistantLinks = async () => AssistantLinksResponse.parse(await request('/api/v1/assistant/links'));
/** F276: o dono libera um número do limite de perguntas por hora. */
export const setAssistantLinkUnlimited = async (id, hourlyUnlimited) => {
    await request(`/api/v1/assistant/links/${id}`, {
        method: 'PATCH',
        body: { hourlyUnlimited },
    });
};
export const removeAssistantLink = async (id) => {
    await request(`/api/v1/assistant/links/${id}`, { method: 'DELETE' });
};
export const fetchAssistantExchanges = async (page) => AssistantExchangesResponse.parse(await request(`/api/v1/assistant/exchanges?page=${String(page)}&pageSize=20`));
export const fetchMyAssistantWhatsapp = async () => MyAssistantWhatsappResponse.parse(await request('/api/v1/assistant/me/whatsapp'));
/** O código já leva o nome de quem vai usar o número (F276). */
export const requestAssistantLinkCode = async (personName) => AssistantLinkCodeResponse.parse(await request('/api/v1/assistant/me/whatsapp/code', {
    method: 'POST',
    body: { personName },
}));
/** O resumo do dia de UM número da pessoa (F273). */
export const setMyAssistantDigest = async (linkId, receivesDigest) => MyAssistantWhatsappResponse.parse(await request(`/api/v1/assistant/me/whatsapp/${encodeURIComponent(linkId)}`, { method: 'PATCH', body: { receivesDigest } }));
/** O nome de quem usa UM número da pessoa (F276). */
export const renameMyAssistantWhatsapp = async (linkId, personName) => MyAssistantWhatsappResponse.parse(await request(`/api/v1/assistant/me/whatsapp/${encodeURIComponent(linkId)}`, { method: 'PATCH', body: { personName } }));
/** Desliga UM número da pessoa (F273). */
export const unlinkMyAssistantWhatsapp = async (linkId) => {
    await request(`/api/v1/assistant/me/whatsapp/${encodeURIComponent(linkId)}`, {
        method: 'DELETE',
    });
};
// ---------------------------------------------------------------------------
// O número do Aeris, na Plataforma (F256)
// ---------------------------------------------------------------------------
export const fetchPlatformAssistant = async () => PlatformAssistantResponse.parse(await request('/api/v1/platform/assistant'));
export const savePlatformAssistant = async (body) => PlatformAssistantResponse.parse(await request('/api/v1/platform/assistant', { method: 'PUT', body }));
export const fetchPlatformAssistantInstances = async (serverId) => PlatformAssistantInstancesResponse.parse(await request(`/api/v1/platform/assistant/instances?serverId=${encodeURIComponent(serverId)}`)).instances;
export const linkPlatformAssistant = async (body) => PlatformAssistantResponse.parse(await request('/api/v1/platform/assistant/link', { method: 'POST', body }));
export const unlinkPlatformAssistant = async (version) => PlatformAssistantResponse.parse(await request('/api/v1/platform/assistant/unlink', {
    method: 'POST',
    body: { version },
}));
/** `start`: acorda a sessão e pede o QR; sem ele, só pergunta onde está. */
export const platformAssistantPairing = async (start) => PlatformAssistantPairing.parse(await request('/api/v1/platform/assistant/pairing', {
    method: start ? 'POST' : 'GET',
}));
export const fetchAccountAssistant = async (tenantId) => PlatformAccountAssistant.parse(await request(`/api/v1/platform/accounts/${tenantId}/assistant`));
export const setAccountAssistantCap = async (tenantId, monthlyCapUsd) => {
    await request(`/api/v1/platform/accounts/${tenantId}/assistant-cap`, {
        method: 'PUT',
        body: { monthlyCapUsd },
    });
};
//# sourceMappingURL=assistant.js.map